import { Heading1, Heading2, Li, P, Stack, Ul } from "@ovotech/element";
import * as React from "react";
import CheckmarkIcon from "_assets/checkmark.svg";
import { EmailContact } from "_core/components/EmailContact";
import { PhoneContact } from "_core/components/PhoneContact";
import { ProductUrls } from "_core/types";
import { Page } from "_core/components";
import { useStore } from "_core/store";

const PersonalDetailsConfirmPageContent = () => {
  const { customerDetails } = useStore();
  return (
    <>
      <Stack spaceBetween={10}>
        <CheckmarkIcon />
        <Heading1 className={"SurfaceHeading"}>
          Thanks for your details,{" "}
          <span data-dd-privacy="mask">{customerDetails?.firstName}</span>!
        </Heading1>
        <div>
          <Heading2 className={"SurfaceHeading"}>
            Your survey link is on its way.
          </Heading2>
          <P size={"lg"}>
            We&apos;ve sent it via text to{" "}
            <span data-dd-privacy="mask">{customerDetails?.phoneNumber}</span>.
            You&apos;ll need to complete it to get your personalised quote.
          </P>
        </div>
        <div>
          <Heading2 className={"SurfaceHeading"}>
            Didn&apos;t get the text?
          </Heading2>
          <Ul>
            <Li>It may take a few minutes to arrive.</Li>
            <Li>
              If you haven&apos;t received your text after a few minutes or if
              you have any questions, &nbsp;give us a call on <PhoneContact />{" "}
              or email us at <EmailContact />.
            </Li>
          </Ul>
        </div>
      </Stack>
    </>
  );
};

export const PersonalDetailsConfirmPage = () => {
  return (
    <Page title="" subtitle="" url={ProductUrls.PersonalDetailsConfirm}>
      <PersonalDetailsConfirmPageContent />
    </Page>
  );
};
